export const datesRegex = /\d{4}-\d{2}-\d{2},\d{4}-\d{2}-\d{2}/;
export const bookingRegex =
    /^((?:([a-zA-Z0-9_]{10}|_),([a-zA-Z0-9]{12}|_),([a-zA-Z0-9]{12}|_),([a-zA-Z0-9]{12}|_),\d+(?:,(?:\d+:\d+)(?:,\d+:\d+)*)?(?:\|[a-zA-Z0-9]{12}(?:,[a-zA-Z0-9]{12})*)?)(?:;|$))+$/;

export const validUrlParams = (q: URLSearchParams): boolean => {
    const regexMap: { [key: string]: RegExp } = {
        d: datesRegex,
        br: bookingRegex,
    };

    // To be enforced with additional checks, works for now
    if (!q.has("p") || !q.has("c")) {
        return false;
    }

    for (const key of q.keys()) {
        if (key in regexMap) {
            for (const value of q.getAll(key)) {
                if (!regexMap[key].test(value)) {
                    return false;
                }
            }
        }
    }

    return true;
};
